import React from "react";
import ConnectorsContainer from "../containers/Manufacturer/Connectors/index";

const ConnectorPage = () => {
  return (
    <>
      <ConnectorsContainer />
    </>
  );
};

export default ConnectorPage;
